import React from "react";
import { useAtom } from "jotai";
import moment from "moment";
import SpinnerLoading from "../common/SpinnerLoading";
import { activeChildDetail } from "../../atomstore/store";
import { useRequestProcessor } from "../../requestProcessor";
import { fetchFood } from "../../queryfunctions/queryfunctions";
import { SERVER_DATE_FORMAT } from "../home/Home";

const FoodMenu = ({ selectedDate }) => {
    const { useQueryWrapper } = useRequestProcessor();
    const [activeChild] = useAtom(activeChildDetail);

    const formattedDate = moment(selectedDate).format(SERVER_DATE_FORMAT);
    const dayName = moment(selectedDate).format("dddd");

    const {
        data: foodData,
        isLoading,
        isFetching,
    } = useQueryWrapper(["food-menu", activeChild?.id, formattedDate], () =>
        fetchFood(formattedDate)
    );

    if (isLoading || isFetching) {
        return (
            <div className="py-12 flex justify-center">
                <SpinnerLoading />
            </div>
        );
    }

    console.log("foodData", foodData)
    if (!foodData || Object.keys(foodData).length === 0 || !foodData?.breakfast) {
        return (
            <div className="space-y-4">
                <div className="bg-gradient-to-r from-orange-500 to-red-500 rounded-2xl p-4 text-white">
                    <h3 className="text-lg font-bold mb-1">{dayName}</h3>
                    <p className="text-sm opacity-90">
                        {moment(selectedDate).format("DD MMMM YYYY")}
                    </p>
                </div>

                <div className="bg-gray-100 rounded-2xl p-8 text-center">
                    <p className="text-gray-500">
                        {moment(selectedDate).day() === 0 || moment(selectedDate).day() === 6
                            ? "No meal service on weekends"
                            : "No food menu available for this date"}
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div className="space-y-4">
            {/* Header */}
            <div className="bg-gradient-to-r from-orange-500 to-red-500 rounded-2xl p-4 text-white">
                <h3 className="text-lg font-bold mb-1">{dayName}</h3>
                <p className="text-sm opacity-90">
                    {moment(selectedDate).format("DD MMMM YYYY")}
                </p>
            </div>

            {/* Food Menu */}
            <div className="bg-white rounded-2xl p-4 shadow-sm border border-gray-100">
                <div className="space-y-3">
                    {foodData?.breakfast && (
                        <div>
                            <div className="flex items-center space-x-2 mb-2">
                                <span className="text-xs bg-yellow-100 text-yellow-700 px-3 py-1 rounded-lg font-medium">
                                    Breakfast
                                </span>
                                {/* <span className="text-xs text-gray-500">8:00 - 9:00 AM</span> */}
                            </div>
                            <p className="text-sm text-gray-700 ml-2">{foodData.breakfast}</p>
                        </div>
                    )}

                    {foodData?.lunch && (
                        <div>
                            <div className="flex items-center space-x-2 mb-2">
                                <span className="text-xs bg-green-100 text-green-700 px-3 py-1 rounded-lg font-medium">
                                    Lunch
                                </span>
                                {/* <span className="text-xs text-gray-500">10:30 - 11:00 AM</span> */}
                            </div>
                            <p className="text-sm text-gray-700 ml-2">{foodData.lunch}</p>
                        </div>
                    )}

                    {foodData?.fruits && (
                        <div>
                            <div className="flex items-center space-x-2 mb-2">
                                <span className="text-xs bg-pink-100 text-pink-700 px-3 py-1 rounded-lg font-medium">
                                    Fruits
                                </span>
                                {/* <span className="text-xs text-gray-500">12:30 - 1:30 PM</span> */}
                            </div>
                            <p className="text-sm text-gray-700 ml-2">{foodData.fruits}</p>
                        </div>
                    )}



                    {foodData?.snacks && (
                        <div>
                            <div className="flex items-center space-x-2 mb-2">
                                <span className="text-xs bg-purple-100 text-purple-700 px-3 py-1 rounded-lg font-medium">
                                    Snack
                                </span>
                                {/* <span className="text-xs text-gray-500">3:00 - 3:30 PM</span> */}
                            </div>
                            <p className="text-sm text-gray-700 ml-2">{foodData.snacks}</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default FoodMenu;
